export const SEND_NUMBER__REQUEST = 'AUTH_TYPE__SEND_NUMBER__REQUEST'
export const SEND_NUMBER__SUCCESS = 'AUTH_TYPE__SEND_NUMBER__SUCCESS'
export const SEND_NUMBER__FAILURE = 'AUTH_TYPE__SEND_NUMBER__FAILURE'
export const SEND_CODE__REQUEST = 'AUTH_TYPE__SEND_CODE__REQUEST'
export const SEND_CODE__SUCCESS = 'AUTH_TYPE__SEND_CODE__SUCCESS'
export const SEND_CODE__FAILURE = 'AUTH_TYPE__SEND_CODE__FAILURE'
export const GET_USER__REQUEST = 'AUTH_TYPE__GET_USER_REQUEST'
export const GET_USER__SUCCESS = 'AUTH_TYPE__GET_USER_SUCCESS'
export const GET_USER__FAILURE = 'AUTH_TYPE__GET_USER_FAILURE'
